import { put, takeEvery, call } from "redux-saga/effects";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { push } from "connected-react-router";
import * as actionTypes from "./constants";
// import { appConfig } from "../../config";
import fmApi from "../APIWrapper";
import { property } from "lodash";

let logoutFailCount = 0;

function* login(cred) {
  try {
    const loginData = {
      username: cred.cred.username,
      password: cred.cred.password,
    };
    // const res = yield fetch(
    //   `${appConfig.urlPrefixIp}/identityservice/user/login`,
    //   {
    //     method: "POST",
    //     headers: {
    //       Accept: "application/json",
    //       "Content-Type": "application/json",
    //     },
    //     body: JSON.stringify(loginData),
    //   }
    // );
    const resJSON = yield call(fmApi.postLogInApi, loginData);

    // if (res.ok) {
    //   throw res;
    // } else {
    //   const resJSON = yield res.json();

    if (resJSON.status === "Success") {
      yield put({
        type: actionTypes.FETCH_LOGIN_SUCCESS_ACTION,
        payload: resJSON,
      });
      // localStorage.setItem("fmsToken", resJSON.access_token);
      yield call(fetchSocprofile, resJSON);
    } else if (resJSON.message === "Invalid credentials") {
      yield toast.error("Invalid credentials", {
        autoClose: 3000,
        position: "top-right",
      });
      yield put({
        type: actionTypes.FETCH_LOGIN_FAIL_ACTION,
      });
    } else {
      yield toast.error("Login failed", {
        autoClose: 3000,
        position: "top-right",
      });
      yield put({
        type: actionTypes.FETCH_LOGIN_FAIL_ACTION,
      });
    }
  } catch (err) {
    // if (err.status === 401) {
    //   yield toast.error("Invalid username", {
    //     autoClose: 3000,
    //     position: "top-right",
    //   });
    // } else {
    //   yield toast.error("Login failed", {
    //     autoClose: 3000,
    //     position: "top-right",
    //   });
    // }
    // yield put({
    //   type: actionTypes.FETCH_LOGIN_FAIL_ACTION,
    //   payload: err,
    // });
  }
}

function* fetchSocprofile(value) {
  // const token = localStorage.getItem("fmsToken");
  try {
    const data = {
      societyId: value.society_id,
    };
    // const res = yield fetch(
    //   appConfig.urlPrefixIp + "/societydataservice/society/profile",
    //   {
    //     method: "POST",
    //     headers: {
    //       Accept: "application/json",
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${token}`,
    //       type: "Web",
    //     },
    //     body: JSON.stringify(data),
    //   }
    // );
    const resJSON = yield call(fmApi.fetchProfileApi, data);

    // if (!res.ok) {
    //   throw res;
    // } else {
    //   const resJSON = yield res.json();
    if (resJSON.response_data.blockPortal == 1) {
      yield put(push("/suspended"));
    } else if (resJSON.response_data.status == "installation") {
      localStorage.setItem("FmsUser", JSON.stringify(value));
      localStorage.setItem(
        "fmsProfDetail",
        JSON.stringify(resJSON.response_data)
      );
      let baccess = localStorage.getItem("baccess");
      if (baccess == "yes") {
        yield put(push("/suspended"));
      } else {
        yield put(push("/onboardingResidents"));
      }
    } else {
      localStorage.setItem("FmsUser", JSON.stringify(value));
      localStorage.setItem(
        "fmsProfDetail",
        JSON.stringify(resJSON.response_data)
      );
      yield put(push("/dashboard"));
      yield call(fetchRwaStatus, value.society_id);
      yield toast.success("Logged in successfully", {
        autoClose: 3000,
      });
    }
    // }
  } catch (err) {}
}

function* fetchRwaStatus(value) {
  // const token = localStorage.getItem("fmsToken");
  try {
    const data = {
      societyId: value,
    };

    const resJSON = yield call(fmApi.fetchRwaStatusApi, data);

    // const res = yield fetch(
    //   appConfig.urlPrefixIp + "/apartmentinfoservice/society/getrwastatus",
    //   {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${token}`,
    //       type: "Web",
    //     },
    //     body: JSON.stringify(data),
    //   }
    // );
    // if (!res.ok) {
    //   throw res;
    // } else {
    // const resJSON = yield res.json();
    localStorage.setItem("rwastatus", resJSON.response_data.status);
    // }
  } catch (err) {}
}

// function* logOut() {
//   const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
//   const societyName = fmsUser.society_name;

//   // localStorage.removeItem("fmsToken");
//   // localStorage.removeItem("FmsUser");
//   // localStorage.removeItem("fmsProfDetail");
//   // localStorage.removeItem("selectedItemData");
//   // localStorage.removeItem("baccess");
//   // localStorage.removeItem("totalConsumption");
//   // localStorage.removeItem("TotalCollectedAmount");
//   // localStorage.removeItem("apartmentLength1");
//   // localStorage.removeItem("rwastatus");
//   const response = yield call(fmApi.fetchLogOutApi, societyName);

//   if (response.status === "Success") {
//     yield put(push("/login"));
//     localStorage.clear();
//   }
//   // localStorage.clear();
// }

function* logOut() {
  try {
    const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
    const societyName = fmsUser?.society_name;

    const response = yield call(fmApi.fetchLogOutApi, societyName);

    if (response?.status === "Success") {
      logoutFailCount = 0;
      localStorage.clear();
      yield put(push("/login"));
      return;
    }

    logoutFailCount += 1;

    if (logoutFailCount > 3) {
      logoutFailCount = 0;
      localStorage.clear();
      yield put(push("/login"));
      return;
    }
    yield toast.error("Failed to logout", {
      autoClose: 3000,
    });
  } catch (error) {
    logoutFailCount += 1;

    if (logoutFailCount > 3) {
      logoutFailCount = 0;
      localStorage.clear();
      yield put(push("/login"));
    }
  }
}

function* getUnit(action) {
  // const data = { property: value.value };
  // const response = yield call(fmApi.getUnitsData, data);
  const { society, resolve } = action.value;
  const data = { property: society };
  const response = yield call(fmApi.getUnitsData, data);

  // when done
  if (resolve) resolve(response);
}

export function* LoginActionWatcher() {
  yield takeEvery(actionTypes.LOGIN_INIT_ACTION, login);
  yield takeEvery(actionTypes.LOGOUT_ACTION, logOut);
  yield takeEvery(actionTypes.GETUNIT_ACTION, getUnit);
}
